import React, { useState } from "react";
import PlusIcon from "@assets/icons/plus.svg";
import UploadIcon from "@assets/icons/upload.svg";
import { Collapse, Descriptions, Table } from "antd";
import { columns, purchasesOrder } from "./mock";
import UploadCSVModal from "../../InventoryOverview/modals/UploadCSVModal";
import AddPurchaseModal from "../../InventoryOverview/modals/PurchaseModals/AddPurchaseModal";
import EditPurchaseModal from "../../InventoryOverview/modals/PurchaseModals/EditPurchaseModal";
import { EMPTY_PURCHASE } from "../../InventoryOverview/forms/utils";
import styles from "../styles.module.scss";

const { Panel } = Collapse;

const renderSummary = (pageData) => {
  let totalCogs = 0;
  let totalQuantity = 0;
  pageData.forEach(({ cogs, quantity }) => {
    totalCogs += cogs;
    totalQuantity += quantity;
  });
  return (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
      <Table.Summary.Cell index={1} />
      <Table.Summary.Cell index={2} />
      <Table.Summary.Cell index={3}>{totalCogs}</Table.Summary.Cell>
      <Table.Summary.Cell index={4}>{totalQuantity}</Table.Summary.Cell>
    </Table.Summary.Row>
  );
};

export const PurchaseTab: React.FC = () => {
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openAddMannual, setOpenAddMannual] = useState(false);

  return (
    <div className={styles.tabContent}>
      <div className={styles.header}>
        <p>Total {purchasesOrder.length} Purchase Orders</p>
        <div className={styles.buttons}>
          <button
            className={styles.blackButton}
            onClick={() => setOpenUploadModal(true)}
          >
            <img src={UploadIcon} alt="Upload CSV" /> Upload CSV
          </button>
          <button
            className={styles.blackButton}
            onClick={() => setOpenAddMannual(true)}
          >
            <img src={PlusIcon} alt="Add PO" /> Add PO Mannually
          </button>
        </div>
      </div>
      <Collapse
        defaultActiveKey={[purchasesOrder[0].orderNumber]}
        className={styles.collapseContentStyle}
        accordion
        ghost
        bordered={false}
      >
        {purchasesOrder.map((po) => (
          <Panel
            key={po.orderNumber}
            header={`Purchase Order: ${po.orderNumber}`}
            className={styles.collapseLabelStyle}
          >
            <Descriptions
              layout="vertical"
              className={styles.descriptionLabelItem}
            >
              <Descriptions.Item label="Supplier name">
                {po.supplierName}
              </Descriptions.Item>
              <Descriptions.Item label="Status">{po.status}</Descriptions.Item>
              <Descriptions.Item label="Order Number">
                {po.orderNumber}
              </Descriptions.Item>
              <Descriptions.Item label="Order date">
                {po.orderDate}
              </Descriptions.Item>
              <Descriptions.Item label="Estimated Completion Date">
                {po.estimatedCompletionDate}
              </Descriptions.Item>
              <Descriptions.Item label="Actual Completion Date">
                {po.actualCompletionDate}
              </Descriptions.Item>
            </Descriptions>
            <Table
              columns={columns}
              dataSource={po.products}
              pagination={false}
              className={styles.table}
              summary={renderSummary}
            />
          </Panel>
        ))}
      </Collapse>
      <UploadCSVModal
        open={openUploadModal}
        onCancel={() => setOpenUploadModal(false)}
        title="Upload Shipment Orders"
        ManualModal={AddPurchaseModal}
        EditModal={EditPurchaseModal}
        onSaveData={() => setOpenUploadModal(false)}
        data={[EMPTY_PURCHASE]}
      />
      <AddPurchaseModal
        open={openAddMannual}
        onCancel={() => setOpenAddMannual(false)}
        onSaveData={() => setOpenAddMannual(false)}
      />
    </div>
  );
};
